/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import RouterService from '@ember/routing/router-service';
import SqlImportModel from 'cio/models/sql-import';
import ApiErrorsService from 'cio/services/api-errors';
import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';
import SqlImportDatabaseModel from 'cio/models/sql-import-database';

interface SqlImportsConfirmAndDeleteArgs {
  model: SqlImportModel;
  onClose: () => unknown;
}

export default class SqlImportsConfirmAndDelete extends Component<SqlImportsConfirmAndDeleteArgs> {
  @service alerts!: AlertsService;
  @service apiErrors!: ApiErrorsService;
  @service analytics!: AnalyticsService;
  @service router!: RouterService;

  deleteTask = dropTask(async () => {
    try {
      let database = this.args.model.belongsTo('database').value() as SqlImportDatabaseModel | null;

      if (database == null) {
        return;
      }

      let { type } = database;

      await this.args.model.destroyRecord();

      this.router.transitionTo('sql-imports', type);
      this.alerts.success('sql-import.deleted', 'Deleted your SQL sync!');
      this.args.onClose();
    } catch (err) {
      this.args.model.rollbackAttributes();
      this.apiErrors.report(err);
    }
  });

  @action
  trackEvent() {
    this.analytics.track('sql_imports', 'sync_delete_started', { model: this.args.model });
  }
}
